import styled from 'styled-components';

export const Wrapper = styled.div`
	min-height: 40px;
	display: flex;
	align-items: center;
	padding-right: 16px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
`;

export const ButtonsWrapper = styled.div`
	display: flex;

	button {
		margin-left: 8px;
	}
`;
